import { AiToolOffice } from '../ai-details/ai-tool-office';
import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { SaveUpdateMemoryCardTemplateComponent } from '../saveUpdateMemoryCardTemplate/saveUpdateMemoryCardTemplate.component';

@Component({
  selector: 'app-importMemoryCardTemplate',
  templateUrl: './importMemoryCardTemplate.component.html',
  styleUrls: ['./importMemoryCardTemplate.component.scss']
})

export class ImportMemoryTemplateComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;


  filteredTaskCategoryList: any = ([] = []);
  ShowNoRecordFoundTaskTemplates: Boolean = false;
  taslTemplateID: number = 0;
  showSaveTemplate: Boolean = false;
  QuestionTemplateID: number = 0;

  updateQuestionTemplateButton: boolean = false;
  selectedcategoryIDForQuestion: number = 0;

  searchTemplateQuestion: string = '';
  categoryType: number = 0;

  timeout = null;

  rolesAsssign: any = [] = [];


  officeIdForImportPromptTemp: number = 0;
  organizationIdForImportPromptTemp: number = 0;
  memoryCardID: number = 0;
  newQuestionsTOUpdate: any = [] = [];
  queryBlocks: any = [] = [];
  ShowNoRecordFoundQuestionTemplate: boolean = false;
 
  currentIndex: number = 0;
  selectedTemplate: any = ([] = []);
  filteredTempCategoryList: any = ([] = []);
  searchTemplateName: string = '';
  ShowNoRecordFoundTemplates: boolean = false;
  ImportTemplatesList: any = ([] = []);
  TemplateIDImportTask: number = 0;
  selectedcategoryIDForImportTemp: number = 0;
  showImportTemplate: boolean = false;
  filteredQualifyingCategoryList: any = ([] = []);
  QualifyingCategoryList: any = ([] = []);
  QualifyingTemplatesList: any = ([] = []);
  QualifyingTemplatesListFilter: any = ([] = []);
  templateID: number = 0;

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<ImportMemoryTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = AiToolOffice.resolve(oe.officeID);   // [per-office] the office the open AI tool works for
      });
    }
  }

  ngOnInit(): void {
    this.getMemoryCardCategories();
    this.getMemoryCards();
  }

  getMemoryCardCategories() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      isCategoriesOnly: true,
      isAll: false,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0,
    };
    this.coreService.getMemoryCardCategories(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.QualifyingCategoryList = response.data;
          this.filteredQualifyingCategoryList = this.QualifyingCategoryList.filter((m: any) => m.type == this.categoryType);
        } else {
          this.QualifyingCategoryList = [];
          this.filteredQualifyingCategoryList = [];
        }
      } else {
        this.QualifyingCategoryList = [];
        this.filteredQualifyingCategoryList = [];
      }
    });
  }

  getMemoryCards() {
    var ReqModel = {
      type: this.categoryType, // For My Template
      categoryID: this.selectedcategoryIDForQuestion,
      isAll: false,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.coreService.getMemoryCards(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.QualifyingTemplatesList = response.data;
          this.QualifyingTemplatesListFilter = response.data;
          if (this.QualifyingTemplatesList.length > 0) {
            this.ShowNoRecordFoundQuestionTemplate = false;
          } else {
            this.ShowNoRecordFoundQuestionTemplate = true;
          }
        } else {
          this.QualifyingTemplatesList = [];
          this.QualifyingTemplatesListFilter = [];
        }
      } else {
        this.QualifyingTemplatesList = [];
        this.QualifyingTemplatesListFilter = [];
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }


  SelectTemplateQuestionTempForImport(data: any) {
    this.memoryCardID = data.memoryCardID;
  }

  getThroughCategoryForQualifyingTempImport(e: any, i: any) {
    this.memoryCardID = 0;
    this.currentIndex = i;
    this.selectedcategoryIDForQuestion = e;
    this.getMemoryCards();
  }

  OnSelectCategoryImportTemp($event: any) {
    this.selectedTemplate = [];
    this.currentIndex = 0;
    this.memoryCardID = 0;
    this.selectedcategoryIDForQuestion = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
    this.categoryType = categoryValue;
    this.getMemoryCardCategories();
    this.getMemoryCards();
  }
  

  importQualifyingTemplates() {
    this.importFromAITools();
  }

  importFromAITools() {
    var ReqModel = {
      memoryCardID: Number(this.memoryCardID),
      referralQuestionID: Number(this.data.questionsData.quetionID),
      referralID: Number(this.data.referralID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.loaderService.show();
    this.coreService.addMemoryCardToReferralQuestion(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success('Memory card associated with referral question successfully.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close('Added');
          //this.closeDialog();
        } else {
          this.toastr.error('Memory card associated with referral question successfully failed.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Memory card associated with referral question successfully failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }
    });
  }

  addMemoryCard() {
    const dialogRef = this.dialog.open(SaveUpdateMemoryCardTemplateComponent, {
      data: {
        //questionsData: item,
        referralID: this.data.referralID,
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.memoryCardID = 0;
        this.getMemoryCardCategories();
        this.getMemoryCards();
      }
    });
  }

}
